var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopylogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 149,
    viewBox: "0 0 128 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.1327,
    y: 21.2294,
    width: 103.881,
    height: 123.944,
    rx: 19.091,
    stroke: "white",
    strokeWidth: 6.73802,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0882 127.035C18.4172 127.023 18.7327 126.889 18.9654 126.653C19.198 126.417 19.3287 126.101 19.3287 125.772C19.3287 125.443 19.198 125.127 18.9654 124.891C18.7327 124.655 18.4172 124.521 18.0882 124.509C14.575 124.386 11.2338 122.748 9.01425 120.171C6.95756 117.817 5.87661 114.726 5.99382 111.684C6.83197 83.2758 7.28699 54.8679 7.35889 26.46C7.36465 24.1826 7.77047 21.925 8.56031 19.8042C11.1946 12.4965 18.625 7.22525 26.4601 7.25119C47.1204 7.07278 67.7807 6.69172 88.441 6.10801C92.6892 5.94353 97.0073 7.76801 99.9215 11.0415C102.245 13.6151 103.654 17.0414 103.783 20.6053C103.795 20.9343 103.929 21.2498 104.165 21.4824C104.401 21.7151 104.717 21.8458 105.046 21.8458C105.375 21.8458 105.691 21.7151 105.927 21.4824C106.163 21.2498 106.298 20.9343 106.31 20.6053C106.467 16.4682 105.1 12.2328 102.476 8.91055C99.2048 4.69111 93.9173 1.99276 88.441 1.89199C67.7807 1.30828 47.1204 0.927222 26.4601 0.748805C15.9768 0.523042 5.80659 7.54467 2.24514 17.4549C1.17352 20.33 0.632276 23.4013 0.64111 26.46C0.713006 54.8679 1.16803 83.2758 2.00618 111.684C2.09125 115.717 3.79163 119.653 6.58512 122.445C9.60209 125.512 13.8977 127.202 18.0882 127.035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylogo);
export default __webpack_public_path__ + "static/media/copy logo.1909bb64e42b3b8fddc71368409269f2.svg";
export { ForwardRef as ReactComponent };